module.exports = __webpack_public_path__ + "static/media/admin_view.49ff6627.svg";